const puzzle = {
  id: "uaJLAOVascwMGw",
  name: "There's a Sentence in There",
  rebuses: [
    {
      id: "8a0198-163c-4121fc1e-ae44-e4123eb6",
      clues: [
        {
          id: "nhrt564-7b-f34234df827",
          clueValues: [
            {
              id: "4a81508-08cb-4177-aa83-8764",
              value:
                "Hotel Oscar Uniform Sierra Tango Oscar November , Whiskey Echo Hotel Alfa Victor Echo Alfa Papa Romeo Oscar Bravo Lima Echo Mike",
              type: "text",
              subtext: "",
              style: {
                width: "calc(100% - 10px)",
              },
            },
          ],
          helperText: "",
          subtext: "",
          clueGroup: 0,
          style: {
            width: "calc(70% - 10px)",
          },
          dependsOn: [],
          solutionInfo: {
            type: "text",
            possibleSolutions: [],
            solvedText: "",
          },
        },
      ],
      style: {},
      solutionInfo: {
        type: "text",
        possibleSolutions: [
          {
            id: "811gf6b7-01a5-897ccd-b599-574d169",
            value: "Houston, we have a problem.",
          },
          {
            id: "811gf6b7-01a5-897ccd-b599-nsaz1",
            value: "Houston, we have a problem.",
          },
        ],
        solvedText: "Houston, we have a problem.",
      },
    },

    {
      id: "8a0328a8-163c-411e-ae44-e4123eb6",
      clues: [
        {
          id: "0cdcabe3-7b-f34234df827",
          clueValues: [
            {
              id: "4a85fc08-08cb-4177-aa83-c8e65651738fed",
              value: "62999 84433 33366677722233 2233 9444844 99966688",
              type: "text",
              subtext: "",
              style: {
                width: "calc(100% - 10px)",
              },
            },
          ],
          helperText:
            "Twentieth letter of the alphabet and the highest single digit number.",
          subtext: "",
          clueGroup: 0,
          style: {
            width: "calc(70% - 10px)",
          },
          dependsOn: [],
          solutionInfo: {
            type: "text",
            possibleSolutions: [],
            solvedText: "",
          },
        },
      ],
      style: {},
      solutionInfo: {
        type: "text",
        possibleSolutions: [
          {
            id: "815dbdb7-01a5-446a-b599-574d83926169",
            value: "May the Force be with you",
          },
          {
            id: "815dbdb7-01a5-8nfS-b599-574d83926169",
            value: "May the Force be with you.",
          },
        ],
        solvedText: "May the Force be with you.",
      },
    },
    {
      id: "8a01229a8-163c-411e-ae44-e4123eb6",
      clues: [
        {
          id: "012cabe3-7b-f34234df827",
          clueValues: [
            {
              id: "4a81208-08cb-4177-aa83-c8e65612fed",
              value: "qn gwc eivb awumbpqvo lwvm zqopb, lw qb gwczamtn.",
              type: "text",
              subtext: "",
              style: {
                width: "calc(100% - 10px)",
              },
            },
          ],
          helperText: "Hail Caesar!",
          subtext: "Et tu, Brute?",
          clueGroup: 0,
          style: {
            width: "calc(70% - 10px)",
          },
          dependsOn: [],
          solutionInfo: {
            type: "text",
            possibleSolutions: [],
            solvedText: "",
          },
        },
      ],
      style: {},
      solutionInfo: {
        type: "text",
        possibleSolutions: [
          {
            id: "815dbdb7-01a5-8nfS-b599-u8172rvjL",
            value: "If you want something done right, do it yourself.",
          },
          {
            id: "815dbdb7-01a5-8nfS-b599-1bcta67",
            value: "If you want something done right, do it yourself",
          },
        ],
        solvedText: "If you want something done right, do it yourself.",
      },
    },
    {
      id: "8a0198-163c-4121fc1e-11-n5612",
      isUnlocked: true,
      clues: [
        {
          id: "nhrt564-7b-u77",
          clueValues: [
            {
              id: "4a81508-65-4177-aa83-8764",
              value: "workshop/uaJLAOVascwMGw/nOtE.png",
              type: "image",
              subtext: "",
              style: {
                width: "calc(100% - 10px)",
              },
            },
          ],
          helperText: "What letters can you find in musical notes?",
          subtext: "",
          clueGroup: 0,
          style: {
            width: "calc(70% - 10px)",
          },
          dependsOn: [],
          solutionInfo: {
            type: "text",
            possibleSolutions: [],
            solvedText: "",
          },
        },
      ],
      style: {},
      solutionInfo: {
        type: "text",
        possibleSolutions: [
          {
            id: "bf91632c5-nvsdt-32-aee1-1cee4c9dgfh68",
            value: "Dad had a headache.",
          },
          {
            id: "a7b1c8f8f-5daf-4b72-bb166-02b5acb6bc1",
            value: "Dad had a headache",
          },
        ],
        solvedText: "Dad had a headache.",
      },
    },
  ],
};

export default puzzle;
